(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecomhub-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cleanups = new WeakMap();
    var lightbox;
    var lightboxImg;
    var photoTrigger;
    document.addEventListener('click', function (event) {
      var play = event.target.closest && event.target.closest('[data-ecomhub-video-play]');
      if (play) {
        var card = play.closest('[data-ecomhub-video-card]');
        var template = card && card.querySelector('template[data-ecomhub-video-embed]');
        if (template && !card.querySelector('iframe')) {
          card.appendChild(template.content.cloneNode(true));
          card.querySelector('iframe').focus();
        }
        return;
      }
      var photo = event.target.closest && event.target.closest('[data-ecomhub-review-photo]');
      if (!photo) return;
      if (!lightbox) {
        lightbox = document.createElement('dialog');
        lightbox.className = 'ecomhub-reviews__lightbox';
        lightbox.setAttribute('aria-label', 'Foto de la reseña');
        lightboxImg = document.createElement('img');
        lightboxImg.alt = 'Foto de la reseña ampliada';
        lightbox.appendChild(lightboxImg);
        document.body.appendChild(lightbox);
        lightbox.addEventListener('click', function () { lightbox.close(); });
        lightbox.addEventListener('close', function () {
          lightbox.classList.remove('is-open');
          lightboxImg.removeAttribute('src');
          if (photoTrigger && photoTrigger.isConnected) photoTrigger.focus();
        });
      }
      photoTrigger = photo;
      lightboxImg.src = photo.getAttribute('data-ecomhub-review-photo');
      lightbox.showModal();
      lightbox.classList.add('is-open');
    });

    function initialize(root) {
    var reveals = root.querySelectorAll('.ecomhub-reviews__reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            entry.target.classList.remove('is-pending');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) {
        el.classList.add('is-pending');
        observer.observe(el);
        cleanups.set(el, function () { observer.unobserve(el); });
      });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    var videoWizards = root.querySelectorAll('[data-ecomhub-video-wizard]');
    videoWizards.forEach(function (wizard) {
      if (wizard.getAttribute('data-ecomhub-initialized') === 'true') return;
      wizard.setAttribute('data-ecomhub-initialized', 'true');
      var section = wizard.closest('.ecomhub-video-wizard');
      var track = wizard.querySelector('.ecomhub-video-wizard__track');
      var originalCards = Array.prototype.slice.call(wizard.querySelectorAll('[data-ecomhub-video-card]'));
      if (!section || !track || originalCards.length < 2) return;

      var lastClone = originalCards[originalCards.length - 1].cloneNode(true);
      var firstClone = originalCards[0].cloneNode(true);
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('data-ecomhub-video-clone', 'true');
      firstClone.setAttribute('data-ecomhub-video-clone', 'true');
      [lastClone, firstClone].forEach(function (clone) {
        clone.setAttribute('inert', '');
        clone.querySelectorAll('video, source, iframe').forEach(function (media) {
          media.removeAttribute('src');
          media.removeAttribute('srcdoc');
          media.removeAttribute('autoplay');
          media.setAttribute('preload', 'none');
        });
      });
      track.insertBefore(lastClone, originalCards[0]);
      track.appendChild(firstClone);

      var cards = Array.prototype.slice.call(wizard.querySelectorAll('[data-ecomhub-video-card]'));
      var position = 1;
      var settleTimer = null;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = section.getAttribute('data-ecomhub-autoplay') !== 'false' && !reducedMotion;
      var parsedInterval = Number(section.getAttribute('data-ecomhub-interval')) || 3000;
      var interval = Math.min(10000, Math.max(2000, parsedInterval));
      var autoplayTimer = null;
      var paused = false;
      var inView = false;
      var boundaryTimer = null;
      var frame = null;

      var alignCard = function (card, smooth) {
        if (!card) return;
        var left = card.offsetLeft - (wizard.clientWidth - card.offsetWidth) / 2;
        wizard.scrollTo({ left: Math.max(0, left), behavior: smooth && !reducedMotion ? 'smooth' : 'auto' });
      };
      var setActive = function (card) {
        var realIndex = card && card.getAttribute('data-ecomhub-video-card');
        cards.forEach(function (candidate) {
          var isActive = candidate === card;
          candidate.classList.toggle('ecomhub-video-wizard__card--active', isActive);
          var shouldPlay = isActive && inView && !document.hidden && !reducedMotion && !candidate.hasAttribute('data-ecomhub-video-clone');
          var iframe = candidate.querySelector('iframe');
          if (iframe && (!isActive || !inView || document.hidden)) iframe.remove();
          var video = candidate.querySelector('video');
          if (!video) return;
          if (shouldPlay) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
        if (realIndex) wizard.setAttribute('aria-label', 'Videos del producto. Video ' + realIndex + ' activo.');
      };
      var resetBoundary = function () {
        if (position === 0) {
          position = originalCards.length;
          alignCard(cards[position], false);
          setActive(cards[position]);
        } else if (position === cards.length - 1) {
          position = 1;
          alignCard(cards[position], false);
          setActive(cards[position]);
        }
      };
      var move = function (direction) {
        position += direction;
        position = Math.min(cards.length - 1, Math.max(0, position));
        alignCard(cards[position], true);
        setActive(cards[position]);
        if (boundaryTimer) window.clearTimeout(boundaryTimer);
        boundaryTimer = window.setTimeout(resetBoundary, reducedMotion ? 0 : 360);
      };
      var stopAutoplay = function () {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };
      var startAutoplay = function () {
        stopAutoplay();
        if (!autoplay || paused || !inView || document.hidden) return;
        autoplayTimer = window.setInterval(function () { move(1); }, interval);
      };

      var previous = section.querySelector('[data-ecomhub-video-prev]');
      var next = section.querySelector('[data-ecomhub-video-next]');
      if (previous) previous.addEventListener('click', function () { move(-1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { move(1); startAutoplay(); });
      cards.forEach(function (card, cardPosition) {
        card.addEventListener('click', function (event) {
          if (event.target && event.target.closest && event.target.closest('button, a, video, iframe')) return;
          if (cardPosition === position) return;
          move(cardPosition > position ? 1 : -1);
          startAutoplay();
        });
      });
      wizard.addEventListener('scroll', function () {
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          var viewportRect = wizard.getBoundingClientRect();
          var center = viewportRect.left + viewportRect.width / 2;
          var nearest = cards.reduce(function (best, card, index) {
            var rect = card.getBoundingClientRect();
            var distance = Math.abs(rect.left + rect.width / 2 - center);
            return !best || distance < best.distance ? { card: card, distance: distance, index: index } : best;
          }, null);
          if (!nearest) return;
          position = nearest.index;
          setActive(nearest.card);
          resetBoundary();
          startAutoplay();
        }, 120);
      }, { passive: true });
      section.addEventListener('mouseenter', function () { paused = true; stopAutoplay(); });
      section.addEventListener('mouseleave', function () { paused = false; startAutoplay(); });
      section.addEventListener('focusin', function () { paused = true; stopAutoplay(); });
      section.addEventListener('focusout', function () { paused = false; startAutoplay(); });
      var syncVisibility = function () { setActive(cards[position]); startAutoplay(); };
      var resize = function () { alignCard(cards[position], false); };
      var visibilityObserver;
      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          syncVisibility();
        }, { threshold: 0.1 });
        visibilityObserver.observe(section);
      } else {
        inView = true;
      }
      document.addEventListener('visibilitychange', syncVisibility);
      window.addEventListener('resize', resize);
      cleanups.set(wizard, function () {
        inView = false;
        stopAutoplay();
        window.clearTimeout(settleTimer);
        window.clearTimeout(boundaryTimer);
        window.cancelAnimationFrame(frame);
        if (visibilityObserver) visibilityObserver.disconnect();
        document.removeEventListener('visibilitychange', syncVisibility);
        window.removeEventListener('resize', resize);
        setActive(null);
      });
      frame = window.requestAnimationFrame(function () {
        alignCard(cards[position], false);
        setActive(cards[position]);
        startAutoplay();
      });
    });
    }
    initialize(document);
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-ecomhub-video-wizard], .ecomhub-reviews__reveal').forEach(function (wizard) {
        var cleanup = cleanups.get(wizard);
        if (cleanup) cleanup();
        cleanups.delete(wizard);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuve-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 1.6 3.15 6.39 7.05 1.02-5.1 4.98 1.2 7.03L12 17.7l-6.3 3.32 1.2-7.03-5.1-4.98 7.05-1.02z"/></svg>';
  const badge = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="currentColor"/><path d="m4.5 8 2.2 2.2 4.8-4.8" fill="none" stroke="white" stroke-width="1.7"/></svg>Verificada';
  const dateText = value => { const [y,m,d] = value.split('-'); return `${Number(d)}/${Number(m)}/${y}`; };
  const sized = (url, width) => { const u = new URL(url); u.searchParams.set('width', width); return u.href; };
  const node = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el; };
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const grid = $('.nr-grid'), more = $('.nr-more'), status = $('.nr-status'), error = $('.nr-error');
    const detail = $('.nr-detail'), write = $('.nr-write-dialog');
    let all = null, pending = null, visible = 10, state = {type:'all', rating:'all', sort:'photos'}, frame;
    const byId = new Map(JSON.parse($('[data-nr-initial]').textContent).map(r => [String(r.id), r]));
    function layout() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        grid.classList.add('nr-masonry');
        const measurements = [...grid.querySelectorAll('.nr-card')].map(card => [card, Math.ceil(card.firstElementChild.getBoundingClientRect().height + 16)]);
        measurements.forEach(([card, height]) => { card.style.gridRowEnd = `span ${height}`; });
      });
    }
    const observer = new ResizeObserver(layout);
    const observe = () => grid.querySelectorAll('.nr-card-inner').forEach(el => observer.observe(el));
    observe(); layout();
    document.fonts?.ready.then(layout);
    async function load() {
      if (all) return all;
      if (!pending) pending = fetch(root.dataset.reviewsUrl).then(response => {
        if (!response.ok) throw Error('Could not load reviews');
        return response.json();
      }).then(data => {
        if (!Array.isArray(data) || data.length !== 623 || data.some(r => !Number.isInteger(r.id) || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5 || typeof r.author !== 'string' || typeof r.body !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(r.date) || (r.photo && !r.photo.startsWith('https://cdn.shopify.com/')))) throw Error('Invalid reviews');
        all = data; data.forEach(r => byId.set(String(r.id),r)); return data;
      }).catch(e => { pending = null; throw e; });
      return pending;
    }
    function card(r) {
      const button = node('button','nr-card'); button.type = 'button'; button.dataset.reviewId = r.id;
      button.setAttribute('aria-label',`Leer reseña de ${r.author}: ${r.rating} de 5 estrellas`);
      const inner = node('span','nr-card-inner');
      if (r.photo) { const image = node('img','nr-photo'); image.src = sized(r.photo,480); image.srcset = `${sized(r.photo,240)} 240w, ${sized(r.photo,480)} 480w`; image.sizes = '(max-width:600px) 45vw, (max-width:1000px) 30vw, 240px'; image.width = 480; image.height = 640; image.loading = 'lazy'; image.decoding = 'async'; image.alt = `Foto compartida por ${r.author}`; inner.append(image); }
      const copy = node('span','nr-card-copy'), author = node('span','nr-author-row'); author.append(node('span','',r.author));
      if (r.verified) { const verified = node('span','nr-verified'); verified.innerHTML = badge; author.append(verified); }
      const date = node('time','',dateText(r.date)); date.dateTime = r.date;
      const stars = node('span','nr-stars'); stars.setAttribute('aria-hidden','true'); stars.innerHTML = star.repeat(r.rating);
      copy.append(author,date,stars,node('span','nr-body',r.body)); inner.append(copy); button.append(inner); return button;
    }
    function filtered() {
      return all.filter(r => (state.type !== 'photos' || r.photo) && (state.rating === 'all' || r.rating === Number(state.rating))).sort((a,b) => {
        if (state.sort === 'photos' && !!a.photo !== !!b.photo) return Number(!!b.photo)-Number(!!a.photo);
        return state.sort === 'oldest' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date);
      });
    }
    function render(reset) {
      const list = filtered(), start = reset ? 0 : grid.querySelectorAll('.nr-card').length;
      if (reset) { observer.disconnect(); grid.replaceChildren(); }
      const fragment = document.createDocumentFragment(); list.slice(start,visible).forEach(r => fragment.append(card(r))); grid.append(fragment);
      status.textContent = `Mostrando ${Math.min(visible,list.length)} de ${list.length} reseñas`;
      more.hidden = visible >= list.length; $('.nr-empty').hidden = list.length > 0;
      observe(); layout();
    }
    let busy = false;
    async function update(next, append = false) {
      if (busy) return;
      busy = true; more.disabled = true; root.setAttribute('aria-busy','true'); error.hidden = true;
      try {
        await load(); state = next; visible = append ? visible + 10 : 10; render(!append);
      } catch (_) { error.hidden = false; }
      finally {
        $('[data-nr-rating]').value = state.rating; $('[data-nr-sort]').value = state.sort;
        root.querySelectorAll('[data-nr-type]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.nrType === state.type)));
        busy = false; more.disabled = false; root.removeAttribute('aria-busy');
      }
    }
    more.addEventListener('click',() => update({...state},true));
    root.querySelectorAll('[data-nr-type]').forEach(button => button.addEventListener('click',() => update({...state,type:button.dataset.nrType})));
    $('[data-nr-rating]').addEventListener('change',e => update({...state,rating:e.target.value}));
    $('[data-nr-sort]').addEventListener('change',e => update({...state,sort:e.target.value}));
    $('.nr-filter-button').addEventListener('click',e => {
      const button = e.currentTarget, open = button.getAttribute('aria-expanded') !== 'true'; button.setAttribute('aria-expanded',String(open)); $('#nr-filters').hidden = !open;
    });
    let returnFocus;
    function open(dialog, trigger) {
      returnFocus = trigger; dialog.showModal(); document.documentElement.classList.add('nr-scroll-lock');
    }
    [detail,write].forEach(dialog => {
      dialog.querySelector('.nr-close').addEventListener('click',() => dialog.close());
      dialog.addEventListener('close',() => { document.documentElement.classList.remove('nr-scroll-lock'); returnFocus?.focus({preventScroll:true}); });
      dialog.addEventListener('click',e => { if (e.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close(); });
    });
    grid.addEventListener('click',e => {
      const trigger = e.target.closest('[data-review-id]'); if (!trigger) return;
      const r = byId.get(trigger.dataset.reviewId); if (!r) return;
      $('#nr-detail-author').textContent = r.author;
      const verified = $('.nr-detail-verified'); verified.innerHTML = r.verified ? badge : ''; verified.hidden = !r.verified;
      const stars = $('.nr-detail-rating .nr-stars'); stars.innerHTML = star.repeat(r.rating); stars.setAttribute('role','img'); stars.setAttribute('aria-label',`${r.rating} de 5 estrellas`);
      const date = $('.nr-detail-rating time'); date.dateTime = r.date; date.textContent = dateText(r.date);
      $('.nr-detail-body').textContent = r.body;
      const media = $('.nr-detail-media'); media.replaceChildren(); media.hidden = !r.photo; detail.classList.toggle('nr-no-photo',!r.photo);
      if (r.photo) { const image = node('img'); image.src = sized(r.photo,1000); image.alt = `Foto compartida por ${r.author}`; image.width = 750; image.height = 1000; media.append(image); }
      open(detail,trigger); detail.scrollTop = 0;
    });
    $('[data-nr-write]').addEventListener('click',e => open(write,e.currentTarget));
    if (write.querySelector('[data-nr-form-result], .errors')) open(write,$('[data-nr-write]'));
  }
  const nearViewport = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { nearViewport.unobserve(entry.target); init(entry.target); } });
  }, {rootMargin:'1800px 0px'}) : null;
  function prepare(root) {
    if (!nearViewport || root.querySelector('[data-nr-form-result], .errors')) init(root);
    else nearViewport.observe(root);
    // Keyboard focus and anchor navigation remain immediately interactive.
    root.addEventListener('focusin', () => init(root), {once:true});
    root.addEventListener('pointerdown', () => init(root), {once:true});
  }
  document.querySelectorAll('.nr[data-reviews-url]').forEach(prepare);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('.nr[data-reviews-url]').forEach(prepare));
})();


  } catch(e) { console.error(e); }
})();
})();
